import { Form as FormikForm } from "formik"

import {
    CTAButton as UiButton,
    DropZone as UiDropZone,
    DatePicker as UiDatePicker,
    FormikSelect,
    Skeleton,
    TagsAutocomplete as L2RTagsAutocomplete,
    Typography,
    styled,
    FileNameTextField,
    styledForMobile,
    MenuItem,
} from "@l2r-front/l2r-ui"

const DROPZONE_DESKTOP_HEIGHT = 408
const DROPZONE_DESKTOP_WIDTH = 400
const DROPZONE_MOBILE_HEIGHT = 220

export const FormContent = styledForMobile("div")(({ theme, isMobile }) => ({
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    gap: theme.spacing(6),
    flex: "1 1 0",
    paddingTop: theme.spacing(2),
    alignItems: "center",
}))

export const DropZone = styledForMobile(UiDropZone)(({ isMobile, theme }) => ({
    width: isMobile ? "100%" : DROPZONE_DESKTOP_WIDTH,
    height: "100%",
    maxHeight: isMobile ? DROPZONE_MOBILE_HEIGHT : DROPZONE_DESKTOP_HEIGHT,
    flex: "0 0 auto",
    marginBottom: isMobile && theme.spacing(6),
}))

export const FieldsWrapper = styledForMobile("div")(({ theme, isMobile }) => ({
    width: isMobile ? "100%" : `calc(50% - ${theme.spacing(4)})`,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: theme.spacing(4),
    padding: !isMobile && theme.spacing(4),
    flex: "0 0 auto",
}))

export const Select = styled(FormikSelect)(() => ({
    width: "100%",
    maxWidth: "100%",
    height: "auto",

    "& .MuiTypography-root": {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
    },
}))

export const TextField = styled(FileNameTextField)(() => ({
    width: "100%",
}))

export const DatePicker = styled(UiDatePicker)(() => ({
    width: "100%",
}))

export const ButtonsWrapper = styled("div")(({ theme, showShadow }) => ({
    backgroundColor: theme.palette["surfaces/surface-primary"].main,
    margin: theme.spacing(0, -8, -8, -8),
    padding: theme.spacing(8),
    display: "flex",
    justifyContent: "right",
    gap: theme.spacing(5),
    boxShadow: showShadow ? theme.shadows[29] : "none",
    zIndex: 1,
}))

export const SubmitButton = styled(UiButton)(({ theme }) => ({
    marginLeft: theme.spacing(2),
    textTransform: "capitalize",
}))

export const FormSkeleton = styled(Skeleton)(() => ({
    transform: "none",
}))

export const ErrorMessage = styled(Typography)(({ theme }) => ({
    color: theme.palette["error/main"].main,
}))

export const TagsAutocomplete = styled(L2RTagsAutocomplete)(({ theme }) => ({
    marginBottom: theme.spacing(3),
}))

export const TypeMenuItem = styled(MenuItem)(() => ({
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
}))

export const TypeIcon = styled("img")(({ theme }) => ({
    width: 24,
    objectFit: "contain",
    marginRight: theme.spacing(4),
    verticalAlign: "bottom",
}))

export const Form = styled(FormikForm)(() => ({
    height: "100%",
    display: "flex",
    flexDirection: "column",
    width: "100%",
}))